import React from 'react';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransition';
import Button from 'Shared/Button';
import classnames from 'classnames';
import Icon from 'Shared/Icon';
import connect from 'Shared/connect';
import { dismissFeedback } from './action-creators';
import * as styles from './base.scss';
class GenericFeedbackBar extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onButtonClick = () => {
            this.props.dismissFeedback();
            if (this.props.feedbackBanner.callback) {
                this.props.feedbackBanner.callback();
            }
        };
        this.state = {
            dismissed: null,
        };
    }
    initTimeout() {
        if (this.props.feedbackBanner.visible && !!!this.props.feedbackBanner.overrideTimeout) {
            if (this.timeout !== null) {
                clearTimeout(this.timeout);
            }
            let timeout = !!this.props.feedbackBanner.timeout
                ? this.props.feedbackBanner.timeout
                : this.props.feedbackBanner.type === 'default' || this.props.feedbackBanner.type === 'success'
                    ? 5000
                    : this.props.feedbackBanner.type === 'warning'
                        ? 10000
                        : 15000;
            this.timeout = setTimeout(() => {
                this.props.dismissFeedback();
            }, timeout);
        }
    }
    componentDidUpdate() {
        this.initTimeout();
    }
    componentDidMount() {
        this.initTimeout();
    }
    render() {
        return (React.createElement(ReactCSSTransitionGroup, { in: this.props.feedbackBanner.visible, classNames: {
                appear: styles.enter,
                appearActive: styles.enterActive,
                enter: styles.enter,
                enterActive: styles.enterActive,
                exit: styles.leave,
                exitActive: styles.leaveActive,
            }, mountOnEnter: true, unmountOnExit: true, appear: true, timeout: { enter: 300, exit: 300 } },
            React.createElement("div", { className: classnames(styles.base, styles[this.props.feedbackBanner.type]), key: "networkErrorMsg" },
                React.createElement("div", { className: styles.wrapper },
                    this.props.feedbackBanner.text,
                    React.createElement(Button, { appearance: 'clear', "data-ta": "close-feedback-banner-button", onClick: this.onButtonClick },
                        React.createElement(Icon, { name: 'close', className: styles.white }))))));
    }
}
export default connect((state) => ({
    feedbackBanner: state.feedbackBanner,
}), (dispatch) => ({
    dismissFeedback() {
        return dispatch(dismissFeedback());
    },
}))(GenericFeedbackBar);
